define(function (require) {
    "use strict";

    var LE = require("app");
    var Button = require("ui/button/Button");

    var template = require("manager-templates/special-occasion/specialOccasionEventsTableEmptyView.tmpl");

    var SpecialOccasionEventsTableEmptyView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionEventsTableEmptyView = Marionette.ItemView.extend({
            template: template,
            tagName: 'tr',
            ui: {
                addDatesButtonContainer: ".add-dates-btn-container"
            },
            uiComponents: {
                addSpecialOccasionEventButton: {
                    type: Button,
                    options: {
                        el: "view.ui.addDatesButtonContainer",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_addEvent"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },

            _initialize: function(options) {
                this.channel = options.channel;
            },

            _addEvent: function() {
                this.channel.trigger("SpecialOccasionEditView:actions:events:new");
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionEventsTableEmptyView;
});
